import { create } from 'zustand';
import { combine } from 'zustand/middleware';

import { type GetPageDataResponse } from '@mc/autolyse/mailchimp.appshell.v1/PageDataService';
import pageDataZeroValues, {
  analyticsZeroValues,
  appConfigZeroValues,
  userDataZeroValues,
} from '@mc/pageData/zeroValues';

const ROOT = __DEV__ ? '/autolyse/dev.php/twirp' : '/autolyse/index.php/twirp';

function getPageDataSync(): GetPageDataResponse {
  const xhr = new XMLHttpRequest();
  const url = `${ROOT}/mailchimp.appshell.v1.PageDataService/GetPageData`;
  const searchParams = Object.fromEntries(
    new URLSearchParams(window.location.search),
  );

  const requestParams = {
    appConfig: {
      referral: searchParams?.referral,
      workflow: searchParams?.workflow,
      supportKey: searchParams?.support_key,
    },
  };

  xhr.open('POST', url, false); // `false` makes the request synchronous
  xhr.setRequestHeader('Content-Type', 'application/json');
  xhr.setRequestHeader('Accept', 'application/json');

  xhr.send(JSON.stringify(requestParams));

  if (xhr.status >= 200 && xhr.status < 300) {
    const response = JSON.parse(xhr.responseText);
    const data = {
      userData: Object.freeze({ ...userDataZeroValues, ...response.userData }),
      appConfig: Object.freeze({
        ...appConfigZeroValues,
        ...response.appConfig,
      }),
      flagsData: Object.freeze(response.flagsData),
      analyticsData: Object.freeze({
        ...analyticsZeroValues,
        ...response.analyticsData,
      }),
    };

    return Object.freeze(data);
  }

  throw new Error(`GetPageData request failed with status ${xhr.status}`);
}

const pageData: GetPageDataResponse | null = window.xp_page_data_async
  ? getPageDataSync()
  : null;

export const usePageDataStore = window.xp_page_data_async
  ? create(
      combine(
        {
          pageData: pageData,
          userData: pageData?.userData ?? userDataZeroValues,
          appConfig: pageData?.appConfig ?? appConfigZeroValues,
          flags:
            pageData?.flagsData.flags ?? pageDataZeroValues.flagsData.flags,
          analyticsData: pageData?.analyticsData ?? analyticsZeroValues,
        },
        () => ({}),
      ),
    )
  : null;

// const useMcStore = create</* Slice types go here*/>()(() => {
// SLICES will go here in our bound store to be used in the React lifecycle.
// Slices should be defined in slices.ts
// ...createSlice(...a),
// });

// export default useMcStore;
